import React, { useEffect, useState } from "react";
import "./WorkFlowAddAssigneeDialog.scss";
import { FilterOptionSchema } from "../Filter/filter.data";
import OutsideAlerter from "../../utils/OutsideClickDetector";

interface ArtworkDialogProps {
  handleClose: () => void;
  allOptions: FilterOptionSchema[];
  selected: number[];
  handleSelection: (option: FilterOptionSchema) => void;
  title: string;
}

const WorkFlowAddAssigneeDialog: React.FC<ArtworkDialogProps> = ({
  handleClose,
  allOptions,
  selected,
  handleSelection,
  title,
}) => {
  const [search, setSearch] = useState("");

  const sortOptionsAlphabetically = (options: FilterOptionSchema[]) => {
    if (options?.length == 0) {
      return [];
    }
    const sorted = options
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .sort((a, b) => {
        return (
          (selected.includes(a.id) ? 0 : 1) - (selected.includes(b.id) ? 0 : 1)
        );
      });
    return sorted;
  };
  const [optionList, setOptionList] = useState<FilterOptionSchema[]>(
    sortOptionsAlphabetically(allOptions)
  );
  const [filteredOptionList, setFilteredOptionList] = useState<
    FilterOptionSchema[]
  >([]);

  useEffect(() => {
    setOptionList(sortOptionsAlphabetically(allOptions));
    setFilteredOptionList(sortOptionsAlphabetically(allOptions));
  }, [allOptions]);

  const searchValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target?.value || "");
    setFilteredOptionList(
      optionList.filter((val) =>
        val.name.toLowerCase().includes(event.target?.value.toLowerCase() || "")
      )
    );
  };

  return (
    <OutsideAlerter action={handleClose}>
      <div className="add-follower-inner-main-container p-8 flex-column gap-12">
        <div className="flex-row gap-4">
          <img
            height={12}
            width={12}
            src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250403125030-user-plus+%281%29.svg"
            alt="user-add-icon"
          />
          <p className="xetgo-font-tag bold">Add {title}</p>
        </div>
        <div className="flex-column gap-8">
          <input
            className="search-value full-width xetgo-font-tag"
            value={search}
            placeholder={`Search ${title}`}
            onChange={searchValue}
          ></input>
          <div className="all-assignees-main-container overflow-scroll flex-column gap-4">
            {filteredOptionList.map((option, index) => (
              <div
                key={index}
                className={`assignee-main-container  ${
                  selected.includes(option.id) &&
                  "selected-assignee-main-container"
                } flex-row align-items-center justify-content-space-between px-8 py-4 cursor-pointer`}
                onClick={() => handleSelection(option)}
              >
                <div className="flex-row gap-8 xetgo-font-tag">
                  <img
                    className="avatar"
                    height={22}
                    width={22}
                    src={option.avatar}
                    alt="avatar"
                  />
                  <p>{option.name}</p>
                </div>
                {selected.includes(option.id) && (
                  <img
                    height={12}
                    width={12}
                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250403132107-check.svg"
                    alt="check-icon"
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </OutsideAlerter>
  );
};

export default WorkFlowAddAssigneeDialog;
